import { toast } from 'sonner'
import type { ZodSchema, z } from 'zod'

/**
 * Run Zod safeParse. On failure, show the first error message via toast.error()
 * and return null. On success, return the parsed (transformed) data.
 */
export function validateAndToast<T extends ZodSchema>(
  schema: T,
  data: unknown,
): z.infer<T> | null {
  const result = schema.safeParse(data)
  if (!result.success) {
    const firstIssue = result.error.issues[0]
    toast.error(firstIssue.message)
    return null
  }
  return result.data
}
